import { getWithParamsRequest } from '../../../../api/utils/provider';
import { ApiResponse } from '../../../../api/utils/responseTransform';

import { DuplicateAccountLocation } from './types';

export async function getDuplicationLocation(
  params,
  signal
): Promise<ApiResponse<{ accountLocations: DuplicateAccountLocation[] }>> {
  return getWithParamsRequest('locations/potential_duplicate_account_locations', params, signal);
}
